import React from "react";
import { useSelector } from "react-redux";
import { Link as RouterLink, Navigate } from "react-router-dom";
import { Box, Button, Card, CardContent, Chip, Stack, Typography } from "@mui/material";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";

import { canAccessAdminConsole } from "utils/platformAccess";

const PlatformAdminRoute = ({ children }) => {
  const user = useSelector((state) => state.auth.user);

  if (!canAccessAdminConsole(user)) {
    return <Navigate to="/projects" replace />;
  }

  if (!user?.mfaEnabled) {
    return (
      <Box p={{ xs: 3, md: 4 }}>
        <Card sx={{ maxWidth: 760, borderRadius: 4 }}>
          <CardContent sx={{ p: { xs: 3, md: 4 } }}>
            <Stack spacing={2.5}>
              <Chip
                icon={<SecurityOutlinedIcon />}
                label="MFA required"
                color="warning"
                variant="outlined"
                sx={{ alignSelf: "flex-start" }}
              />
              <Box>
                <Typography variant="h4" fontWeight={700} gutterBottom>
                  Enable MFA to access the admin console
                </Typography>
                <Typography color="text.secondary">
                  Admin and super admin accounts must enable multi-factor
                  authentication before using platform-admin tools. Turn on MFA
                  in Security settings, then return to the admin page.
                </Typography>
              </Box>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
                <Button
                  component={RouterLink}
                  to="/settings?tab=security&adminMfaRequired=1"
                  variant="contained"
                >
                  Open Security Settings
                </Button>
                <Button
                  component={RouterLink}
                  to="/projects"
                  variant="text"
                  sx={{ color: "common.white" }}
                >
                  Back to Projects
                </Button>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return children;
};

export default PlatformAdminRoute;